<template>
  <div>
    <v-row v-if="content">
      <v-col cols="10" offset="1">
        <v-row>
          <v-col cols="12">
            <h2 class="headline mb-4" v-text="$t('exercise_four_corners.title')"></h2>

            <p v-for="(item, index) in $t('exercise_four_corners.description')" :key="index" v-text="item" />
          </v-col>
          <v-col cols="6" v-for="item in content.items" :key="item.id">
            <v-card light :to="`/users/project/${$route.params.id}/${item.slug}`" height="100%">
              <v-card-title>
                <h3 class="overline" v-if="item.part">{{ item.part }}</h3>
              </v-card-title>
              <v-card-subtitle>
                <h2 class="headline black--text">{{ item.title }}</h2>
                {{ item.text }}
              </v-card-subtitle>

              <v-card-actions>
                <v-btn light color="amber" class="mb-2">View</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// @ is an alias to /src
// const fb = require("@/firebaseConfig.js");

export default {
  name: "UserFourCornersMenu",
  async created() {
    // GET request using fetch with async/await
    const response = await fetch(`/content/${this.$route.params.id}.json`);
    const data = await response.json();
    this.content = data;
  },

  data() {
    return {
      content: null,
      items: [
        {
          id: 0,
          title: "Client",
          part: "Part 1",
          text: "(Brand Ambition and Equity)",
          slug: "four-corners/client/shared",
        },
        {
          id: 1,
          title: "Customer",
          part: "Part 2",
          text: "(Expectations and Motivations)",
          slug: "four-corners/customer/shared",
        },
        {
          id: 2,
          title: "Context",
          part: "Part 3",
          text: "(Trends, social, cultural, technical etc)",
          slug: "four-corners/context/shared",
        },
        {
          id: 3,
          title: "Competition",
          part: "Part 4",
          text: "(Direct and Indirect)",
          slug: "four-corners/competition/shared",
        },
      ],
    };
  },

  mounted() {
    this.init();
  },
  methods: {
    init() { },
  },
};
</script>

<style lang="scss"></style>
